import { Box, SxProps, Theme, Typography } from '@mui/material';
import { UseTableCellProps } from 'react-table';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

export function TextColumn(props: UseTableCellProps<any>) {
  const { value } = props;
  const displayValue = value ? (value as string).replaceAll(' ', '\xa0') : value;
  return (
    <Box sx={gridStyles}>
      <Typography variant='body2'>{displayValue}</Typography>
    </Box>
  );
}
